import { EdgeListEventOptionsRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { ListEventOptions } from '@/shared/domain/use-cases'

export function makeListEventOptions(): ListEventOptions {
  return new EdgeListEventOptionsRepository(makeSupabaseEdgeHttpClient()).execute
}
